import script from "./activity-product-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./activity-product-item.vue?vue&type=script&lang=ts&setup=true"

import "./activity-product-item.vue?vue&type=style&index=0&id=77b1a912&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77b1a912"]])

export default __exports__